module.exports = __webpack_public_path__ + "static/media/img-cole-sua-tag@3x.3c80d186.png";